<template>
  <div class="site-header-cart">
    <a class="site-header-cart--button" href="#" @click="toggleOpen()">
      {{ buttonText }}
      <span class="visually-hidden">{{ buttonA11yText }}</span>
    </a>
    <span class="site-header-cart-count" @click="toggleOpen()">
      {{ itemCount }} {{ itemCountLabel }}
    </span>
    <a class="account-link" :href="accountLinkUrl">
      {{ accountLinkText }}
    </a>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { flyoutCart, mutations } from './store';

export default {
  name: 'FlyoutCartToggle',
  props: {
    accountLinkUrl: {
      type: String
    },
    accountLinkText: {
      type: String
    },
    buttonA11yText: {
      type: String
    },
    buttonText: {
      type: String
    },
    itemCountLabelSingle: {
      type: String
    },
    itemCountLabelMultiple: {
      type: String
    }
  },
  computed: {
    ...mapState(flyoutCart, ['itemCount']),

    itemCountLabel() {
      if (this.itemCount === 1) {
        return this.itemCountLabelSingle;
      }

      return this.itemCountLabelMultiple;
    }
  },
  methods: {
    ...mapMutations({
      toggleOpen: `${flyoutCart}/${mutations.TOGGLE_OPEN}`
    })
  }
};
</script>
